import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import moment from 'moment';
import * as Api from 'api';
import { FieldList } from 'components';
import { Col, Row, Button, Alert } from 'react-bootstrap';
import { copy } from 'utils';

class UserTable extends Component {
  static propTypes = {
    onSelectUser: PropTypes.func,
    selected: PropTypes.arrayOf(PropTypes.string),
  }
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handlePageSizeChange = this.handlePageSizeChange.bind(this);
    this.getUsers = this.getUsers.bind(this);
    this.handleSortingChange = this.handleSortingChange.bind(this);

    this.state = {
      results: [],
      size: 20,
      offset: 0,
      sort: {},
      selected: this.props.selected || [],
      selected_filters: [],
    }
    this.state.columns = [
      {
        header: 'Username',
        accessor: 'username'
      },
      {
        header: 'Name',
        id: 'name',
        accessor: d => d.name? `${ d.name.first } ${ d.name.last }` : '(none)'
      },
      {
        header: 'Screen Name',
        accessor: 'screen_name'
      },
      {
        header: '# Purchased Maps',
        id: 'purchased_maps',
        accessor: d => d.purchased_maps.length
      },
      {
        header: 'Address',
        accessor: 'formatted_address'
      },
      {
        header: 'Personal Phone',
        accessor: 'personal_phone'
      },
      {
        header: 'Work Phone',
        accessor: 'work_phone'
      },
      {
        header: 'Last Login',
        id: 'last_login',
        accessor: d => moment(d.last_login).format('MM/DD/YYYY hh:mm:ss a')
      },
      {
        header: 'Last Login IP',
        accessor: 'last_login_ip'
      },
      {
        header: 'Account User Limit',
        accessor: 'account_user_limit'
      },
      {
        header: 'Users In Account',
        accessor: 'users_in_account'
      },
      {
        header: 'Owner Account',
        accessor: 'owner_account'
      }
    ]

    //Setup data
    Api.fetchUsers({ size: this.state.size })
      .then(response => this.setState({ ...response }))
      .catch(error => this.setState({ error }));

    Api.fetchUsersFilters()
      .then(response => this.setState({ available_filters: [
          ...(this.state.available_filters || []),
          ...response.filters
        ]
      }))
      .catch(error => this.setState({ error }))

    Api.getNotificationGroups()
      .then(groups => {
        this.setState({
          available_filters: [
            ...(this.state.available_filters || []),
            ...groups.map(({ name, category }) => ({ label: `Notification Group - ${category} - ${name}`, value: JSON.stringify({ name, category }), type: 'notification_group'}))
          ]
        })
      })
      .catch(error => this.setState({ error }))
  }
  getUsers() {
    const { size, selected_filters, offset, sort } = this.state;
    const filters = {};

    if(selected_filters.length > 0) {
      filters.$or = selected_filters.map(filter => {
        switch(filter.type) {
          case 'feature':
            return { 'features' : filter.value }
          case 'notification_group':
            let group = JSON.parse(filter.value);
            return { 'settings.user_notification_groups.name': group.name, 'settings.user_notification_groups.category': group.category }
        }
      });
    }
    if(this.props.onChangeFilters) {
      this.props.onChangeFilters(filters);
    }
    this.setState({ loading: true });
    Api.fetchUsers({
      size,
      filters,
      sort,
      offset
    })
    .then(results => this.setState({ ...results, loading: false }))
    .then(f => this.props.onUpdate? this.props.onUpdate(this.state) : null)
    .catch(error => this.setState({ error, loading: false }));

  }
  handleChange(value) {
    this.setState({ selected_filters: value }, this.getUsers);
  }
  handlePageChange(pageIndex) {
    this.setState({ offset: pageIndex }, this.getUsers);
  }
  handlePageSizeChange(pageSize, pageIndex) {
    this.setState({ size: pageSize, offset: pageIndex }, this.getUsers);
  }
  handleSortingChange(column, shiftKey) {
    const copySort = copy(this.state.sort);

    if(this.state.sort[column.id] == -1) {
      delete copySort[column.id];
    } else {
      copySort[column.id] = this.state.sort[column.id] == 1 ? -1 : 1;
    }

    if(shiftKey) {
      this.setState({
        sort: copySort
      }, this.getUsers);
    }
    else {
      const newSort = {};
      if(typeof copySort[column.id] !== 'undefined') {
        newSort[column.id] = copySort[column.id];
      }
      this.setState({
        sort: newSort
      }, this.getUsers);
    }
  }
  render() {
    const sorting = Object.keys(this.state.sort)
      .filter(name => this.state.sort[name] != 0)
      .map(name => ({
        id: name,
        desc: this.state.sort[name] == -1 ? true : false
      }));

    return (
      <div>
        <Row>
          <Col xs={12} md={6} lg={4} className='mb-none'>
            <FieldList
              hidePanel={true}
              groupHeadings={false}
              entity={{ filters: this.state.selected_filters.map(({value}) => value) }}
              onChange={this.handleChange}
              returnSelectValueAsObject={true}
              fields={[
                {
                  type: 'multiselect',
                  name: 'filters',
                  label: 'Filters',
                  placeholder: 'Select Filters',
                  options: this.state.available_filters || []
                }
              ]}
            />
          </Col>
          <Col xs={12} md={4}>
            <label className='control-label mt-sm'>Refresh</label><br />
            <Button onClick={e => this.getUsers()}><i className={`fa fa-refresh${this.state.loading? ' fa-spin' : ''}`} /></Button>
          </Col>
          {this.state.error ? (
            <Col xs={12} md={4}>
                <Alert bsStyle='danger' onDismiss={e => this.setState({ error: null })}>
                  {this.state.error.message}
                </Alert>
            </Col>
          ) : null}
          <Col xs={12}>
            <p className="text-muted pull-right">{this.state.total} Users</p>
          </Col>
        </Row>
        <ReactTable
          manual
          loading={this.state.loading}
          page={this.state.offset}
          pageSize={this.state.size}
          pages={Math.ceil(this.state.total/this.state.size)}
          className="-striped -highlight"
          data={this.state.results}
          columns={this.state.columns}
          defaultPageSize={this.state.size}
          onPageChange={this.handlePageChange}
          onPageSizeChange={this.handlePageSizeChange}
          onSortingChange={this.handleSortingChange}
          sorting={sorting}
        />
      </div>
    )
  }
}

export default UserTable;



// WEBPACK FOOTER //
// ./src/browser/components/users/user-table.js